import React, { createContext, useState, useContext, useEffect } from 'react';
import { translations } from '../translations';
import jsonData from '../data.json';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
    const [language, setLanguage] = useState('tr');
    
    useEffect(() => {
        const savedLanguage = localStorage.getItem('language');
        if (savedLanguage) {
            setLanguage(savedLanguage);
        }
    }, []);

    const toggleLanguage = () => {
        const newLanguage = language === 'tr' ? 'en' : 'tr';
        setLanguage(newLanguage);
        localStorage.setItem('language', newLanguage);
    };

    const t = (key) => {
        const keys = key.split('.');
        let value = translations[language];
        for (let k of keys) {
            value = value?.[k];
        }
        return value || key;
    };

    // Helper to get data from data.json based on language
    // If data.json is structured with 'tr' and 'en' keys, use this:
    const data = jsonData[language] || jsonData['tr']; 

    return (
        <LanguageContext.Provider value={{ language, toggleLanguage, t, data }}>
            {children}
        </LanguageContext.Provider>
    );
};

export const useLanguage = () => useContext(LanguageContext);
